import React, {useEffect} from "react"
import "./index.scss"
import SimpleBarChart from "../../components/Charts/BarChart/SimpleBarChart"
import ChartContainer from "../../components/Charts/ChartContainer"
import {useManualQuery} from "graphql-hooks"
import {UseStores} from "../../hooks/UseStores"
import {observer} from "mobx-react-lite"
import {CROSSOVER_BRANDS_QUERY} from "../../gql/gqlInsights"
import {insightClient} from "../../gql/gqlInterceptor"
import {brandIdToSicCode} from "../../utils/utils"
import {Spinner} from "../../components/Spinner"
import InternalError from "../../components/InternalError"
import {chartsPallete} from "../../assets/shared/colorConstants"
import EmptyDataContainer from "../../pages/Insights/EmptyDataContainer"

const TopCrossoverBrands = () => {
  let domChart = null
  let query = CROSSOVER_BRANDS_QUERY
  const label = "Top Crossover Brands"
  const type = "top_crossover_brands"

  const {insightStore, insightsPopupStore} = UseStores()

  const brandId = insightStore.brandId
  const sicCode = brandIdToSicCode(brandId)
  const month = insightStore.insightMonth
  const marketType = insightStore.insightMarketType
  const marketTypeValue = insightStore.insightMarketTypeValue
  const skipCache = insightsPopupStore.skipCacheForCrossoverBrands
  const csvData = []
  const chartData = []
  let maxShare = null
  let minShare = null

  const [fetchData, {loading, error, data}] = useManualQuery(query, {
    variables: {brandId, sicCode, month, marketType, marketTypeValue},
    client: insightClient,
    skipCache: skipCache,
  })

  useEffect(() => {
    if (month !== "") {
      fetchData()
    }
  }, [month, sicCode, brandId, marketType, marketTypeValue])

  if (loading) {
    domChart = (
      <div align="center">
        <Spinner size="medium" />
      </div>
    )
  }

  if (error) {
    insightsPopupStore.setSkipCacheForCrossoverBrands(true)
    domChart = (
      <div className="error-message-container">
        <InternalError />
      </div>
    )
  }

  if (data && data.marketShare) {
    insightsPopupStore.setSkipCacheForCrossoverBrands(false)

    const crossOverBrandsMarketShare = data.marketShare.marketShareOfCrossOverBrands

    if (crossOverBrandsMarketShare.length === 0) {
      domChart = <EmptyDataContainer />
    } else {
      const maxCrossOverVisit = crossOverBrandsMarketShare[0].crossVisits
      const crossoverBrandsShareList = []

      for (let i = 1; i < crossOverBrandsMarketShare.length && i < 16; i++) {
        const crossOverVisit = crossOverBrandsMarketShare[i].crossVisits
        const crossoverBrandsShare = ((crossOverVisit / maxCrossOverVisit) * 100).toFixed(
          2
        )
        crossoverBrandsShareList.push(Number(crossoverBrandsShare))
        csvData.push({
          "Brand Name": crossOverBrandsMarketShare[i].brandName,
          "%Shared Visitors": `${Number(crossoverBrandsShare)}%`,
        })
        chartData.push({
          BrandName: crossOverBrandsMarketShare[i].brandName,
          SharedVisitors: Number(crossoverBrandsShare),
        })
      }

      if (crossoverBrandsShareList.length) {
        minShare = `${Math.min(...crossoverBrandsShareList)}%`
        maxShare = `${Math.max(...crossoverBrandsShareList)}%`
      }

      domChart = (
        <SimpleBarChart
          chartData={chartData}
          xDataKey="BrandName"
          yDataKey="SharedVisitors"
          color={chartsPallete[1]}
          barSize={12}
          chartHeight={258}
          showEllipsis={true}
          marginTop={40}
        />
      )
    }
  }

  return (
    <ChartContainer
      type={type}
      csvData={csvData}
      label={label}
      hideDownload={true}
      showMinMax={error ? false : true}
      max={maxShare}
      min={minShare}
    >
      {domChart}
    </ChartContainer>
  )
}
export default observer(TopCrossoverBrands)
